var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellularConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9386 1.79175C19.9386 1.17043 19.4611 0.666748 18.872 0.666748H17.8053C17.2162 0.666748 16.7386 1.17043 16.7386 1.79175V11.5417C16.7386 12.1631 17.2162 12.6667 17.8053 12.6667H18.872C19.4611 12.6667 19.9386 12.1631 19.9386 11.5417V1.79175ZM12.5053 3.06675H13.5719C14.1611 3.06675 14.6386 3.58252 14.6386 4.21875V11.5147C14.6386 12.151 14.1611 12.6667 13.5719 12.6667H12.5053C11.9162 12.6667 11.4386 12.151 11.4386 11.5147V4.21875C11.4386 3.58252 11.9162 3.06675 12.5053 3.06675ZM8.17195 5.66675H7.10528C6.51618 5.66675 6.03862 6.18908 6.03862 6.83341V11.5001C6.03862 12.1444 6.51618 12.6667 7.10528 12.6667H8.17195C8.76105 12.6667 9.23862 12.1444 9.23862 11.5001V6.83341C9.23862 6.18908 8.76105 5.66675 8.17195 5.66675ZM2.87195 8.06675H1.80528C1.21618 8.06675 0.738617 8.58162 0.738617 9.21675V11.5167C0.738617 12.1519 1.21618 12.6667 1.80528 12.6667H2.87195C3.46105 12.6667 3.93862 12.1519 3.93862 11.5167V9.21675C3.93862 8.58162 3.46105 8.06675 2.87195 8.06675Z",
    fill: "#141E0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellularConnection);
export default __webpack_public_path__ + "static/media/cellular-connection.cb875cb7368dcdcc74eb9d32f3ae0fe5.svg";
export { ForwardRef as ReactComponent };